// extracted by mini-css-extract-plugin
export default {"component":"bDZZVr","disabled":"cDZZVr","icon":"dDZZVr","iconLeft":"eDZZVr","iconRight":"fDZZVr","size-100":"gDZZVr","size-200":"hDZZVr","size-300":"iDZZVr","size-400":"jDZZVr"};